// extracted by mini-css-extract-plugin
export default {"productCarousel":"K4-z"};